const BillingInvoiceItem = ({
    chargeAmount = '',
    chargeName = [],
    city = '',
    feedId = '',
    feedListingId = '',
    productName = '',
    propertyName = '',
    quantity = 0,
    serviceEndDate = '',
    serviceStartDate = '',
    state = '',
    address = '',
    unit = '',
    activeRanges = '',
    contactEmail = '',
    contactPhone = '',
    discountPercent = 0,
    feedCompanyName = '',
} = {}) => ({
    chargeAmount: Number(chargeAmount),
    chargeName: String(chargeName),
    city: String(city),
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    productName: String(productName),
    propertyName: String(propertyName),
    quantity: Number(quantity),
    serviceEndDate: String(serviceEndDate),
    serviceStartDate: String(serviceStartDate),
    state: String(state),
    address: String(address),
    unit: String(unit),
    activeRanges: String(activeRanges),
    contactEmail: String(contactEmail),
    contactPhone: String(contactPhone),
    discountPercent: Number(discountPercent),
    feedCompanyName: String(feedCompanyName),
});

export default BillingInvoiceItem;
